"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _Text = require("../../Text/Text");
var _excluded = ["classes", "className", "theme"];
/*:: // 

import { type Node } from 'react';*/
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      textTransform: 'uppercase',
      color: theme.colors.battleshipGrey,
      paddingBottom: '.75rem',
      fontWeight: 700,
      borderBottom: "1px solid ".concat(theme.colors.lightGrey)
    }
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  children: Node
};*/
var PaneTitle = function PaneTitle(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement(_Text.Header6, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props));
};
PaneTitle.displayName = 'PaneTitle';
var _default = exports.default = (0, _injectSheet.default)(Style)(PaneTitle);
//# sourceMappingURL=PaneTitle.js.map